<template>
	<PassoAPasso
		:title="title"
		:subtitle="subtitle"
		:warning="warning"
		:breadclumb="breadclumb"
		:linkManual="lastChoice?.linkManual"
		:description="description"
		:cards="cards"
		:vimeoId="vimeoId"
	>
		<template v-slot:cards>
			<li
				class="flex items-center text-center w-full"
				style="grid-template-columns: max-content 1fr"
			>
				<span
					class="grid place-items-center mr-6 rounded-full bg-spc text-3xl w-12 h-12 text-white font-bold leading-none"
					>1</span
				>
				<div
					class="flex flex-col justify-start items-start bg-white rounded-md w-full p-4"
					style="max-width: 443px"
				>
					<h3
						class="text-left text-base text-spc font-bold"
					>
						Passo 1
					</h3>
					<p
						class="text-gray-600 text-sm col-start-2 text-left"
					>
						Desconecte a mídia
						(token/cartão) do seu
						computador.
					</p>
				</div>
			</li>
			<li
				class="flex items-center text-center w-full"
				style="grid-template-columns: max-content 1fr"
			>
				<span
					class="grid place-items-center mr-6 rounded-full bg-spc text-3xl w-12 h-12 text-white font-bold leading-none"
					>2</span
				>
				<div
					class="flex flex-col justify-start items-start bg-white rounded-md w-full p-4"
					style="max-width: 443px"
				>
					<h3
						class="text-left text-base text-spc font-bold"
					>
						Passo 2
					</h3>
					<p
						class="text-gray-600 text-sm col-start-2 text-left"
					>
						Selecione o sistema operacional
						do seu computador.
					</p>
					<SelectOption
						:values="options"
						v-model="choices.plataform"
						placeholder="Plataforma"
						class="mt-4 w-full md:w-1/2 xl:w-1/2"
					/>
				</div>
			</li>
			<li
				class="flex items-center text-center w-full"
				:data-step="!choices.plataform"
				style="grid-template-columns: max-content 1fr"
			>
				<span
					class="grid place-items-center mr-6 rounded-full bg-spc text-3xl w-12 h-12 text-white font-bold leading-none"
					>3</span
				>
				<div
					class="flex flex-col justify-start items-start bg-white rounded-md w-full p-4"
					style="max-width: 443px"
				>
					<h3
						class="text-left text-base text-spc font-bold"
					>
						Passo 3
					</h3>
					<p
						class="text-gray-600 text-sm col-start-2 text-left"
					>
            Selecione o tipo de sistema do seu computador.
					</p>
					<p
						v-if="choices.plataform === 'windows'"
						class="text-gray-600 text-sm col-start-2 text-left mt-2"
					>
            <b>Dica:</b> Para verificar a informação, vá no menu Iniciar e pesquise por Sistemas. 
					</p>
					<p
						v-if="choices.plataform === 'macos'"
						class="text-gray-600 text-sm col-start-2 text-left mt-2"
					>
            <b>Dica:</b> Para verificar a informação, vá no menu Apple no canto superior da tela e selecione Sobre este MAC
					</p>
					<SelectOption
						:values="optionsPlataformVersion"
						:disabled="!choices.plataform"
						v-model="choices.plataformVersion"
						placeholder="Selecione o tipo"
						class="mt-4 w-full md:w-1/2 xl:w-1/2"
					/>
				</div>
			</li>
			<li
				class="flex items-center text-center w-full"
				:data-step="!choices.plataformVersion"
				style="grid-template-columns: max-content 1fr"
			>
				<span
					class="grid place-items-center mr-6 rounded-full bg-spc text-3xl w-12 h-12 text-white font-bold leading-none"
					>4</span
				>
				<div
					class="flex flex-col justify-start items-start bg-white rounded-md w-full p-4"
					style="max-width: 443px"
				>
					<h3
						class="text-left text-base text-spc font-bold"
					>
						Passo 4
					</h3>
					<p
						class="text-gray-600 text-sm col-start-2 text-left"
					>
          Selecione o seu tipo de mídia.  
					</p>
					<SelectOption
						:values="optionsMidia"
						:disabled="!choices.plataformVersion"
						v-model="choices.midia"
						placeholder="Mídia"
						class="mt-4 w-full md:w-1/2 xl:w-1/2"
					/>
				</div>
			</li>
			<li
				:data-step="!choices.midia"
				class="flex items-center text-center w-full"
				style="grid-template-columns: max-content 1fr"
			>
				<span
					class="grid place-items-center mr-6 rounded-full bg-spc text-3xl w-12 h-12 text-white font-bold leading-none"
					>5</span
				>
				<div
					class="flex flex-col justify-start items-start bg-white rounded-md w-full p-4"
					style="max-width: 443px"
				>
					<h3
						class="text-left text-base text-spc font-bold"
					>
						Passo 5
					</h3>
					<p
						class="text-gray-600 text-sm col-start-2 text-left"
					>
          Selecione o modelo da sua mídia.
					</p>
					<SelectOption
						:values="optionsModel"
						:disabled="!choices.midia"
						v-model="choices.model"
						placeholder="Modelo"
						class="mt-4 w-full md:w-1/2 xl:w-1/2"
					/>
				</div>
			</li>
			<li
				:data-step="!choices.model"
				class="flex items-center text-center w-full"
				style="grid-template-columns: max-content 1fr"
			>
				<span
					class="grid place-items-center mr-6 rounded-full bg-spc text-3xl w-12 h-12 text-white font-bold leading-none"
					>6</span
				>
				<div
					class="flex flex-col justify-start items-start bg-white rounded-md w-full p-4"
					style="max-width: 443px"
				>
					<h3
						class="text-left text-base text-spc font-bold"
					>
						Passo 6
					</h3>
					<p
						class="text-gray-600 text-sm col-start-2 text-left"
					>
          Faça o download do driver do seu certificado e execute o programa. Em seguida, conecte a mídia no seu computador.
					</p>
					<a :href="linkDownload" :disabled="!linkDownload" class="flex justify-start align-items py-2 px-8 gap-x-2 w-max bg-spc-100 data-[disabled]:bg-gray-500 button-common focus-within:box-border mt-4 font-bold text-white rounded-full">
						<img src="/certificacaodigital/images/instalacao/download.svg" class="w-5 h-5"/>
						Download
					</a>
				</div>
			</li>
			<li
				:data-step="!choices.model"
				class="flex items-center text-center w-full"
				style="grid-template-columns: max-content 1fr"
			>
				<span
					class="grid place-items-center mr-6 rounded-full bg-spc text-3xl w-12 h-12 text-white font-bold leading-none"
					>7</span
				>
				<div
					class="flex flex-col justify-start items-start bg-white rounded-md w-full p-4"
					style="max-width: 443px"
				>
					<h3
						class="text-left text-base text-spc font-bold"
					>
						Passo 7
					</h3>
					<p
						class="text-gray-600 text-sm col-start-2 text-left"
					>
          Pronto! O seu certificado está instalado e pronto pra uso.
					</p>
				</div>
			</li>
		</template>
	</PassoAPasso>
</template>
<script>
import SelectOption from "@/components/inputs/SelectForm.vue";
import PassoAPasso from "./PassoAPasso.vue";

export default {
	props: {
		title: String,
		subtitle: String,
		breadclumb: Array,
		description: String,
		linkManual: String,
		warning: [String, undefined],
		cards: Array,
	},
	computed: {
		optionsPlataformVersion() {
			const plataform = this.options.find(
				(item) => item.id === this.choices.plataform
			);
			return plataform?.versions ?? [];
		},
		vimeoId () {
			return this.lastChoice?.vimeoId
		},
		optionsMidia() {
			const version = this.optionsPlataformVersion.find(
				(item) =>
					item.id ===
					this.choices.plataformVersion
			);
			return version?.midias ?? [];
		},
		optionsModel() {
			const midia = this.optionsMidia.find(
				(item) => item.id === this.choices.midia
			);
			return midia?.models ?? [];
		},
		lastChoice () {
			return this.optionsModel.find(item => item.id === this.choices.model)
		},
    linkDownload () {
      return this.lastChoice?.download ?? ""
    }
	},
  watch: {
    "choices.plataform"() {
      this.choices.plataformVersion = null
      this.choices.midia = null
      this.choices.model = null
    },
    "choices.plataformVersion"() {
      this.choices.midia = null
      this.choices.model = null
    },
    "choices.midia"() {
      this.choices.model = null
    },
  },
	data() {
		return {
			choices: {
				plataform: null,
				midia: null,
				model: null,
				plataformVersion: null,
			},
			options: [
				{
					id: "windows",
					label: "Windows",
					versions: [
						{
							id: "64-bit",
							label: "64-bit",
							midias: [
								{
									id: "token",
									label: "Token",
									models: [
										{
											id: "safenet",
											label: "SafeNet",
											download: "/uploads/hotsite_certificado_digital/safenet_64bits_v10.7.msi",
											vimeoId: 1038600640,
											linkManual: '/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_manual_safenet_windows.pdf'
										},
										{
											id: "geiseck--devrient-gd",
											label: "Geiseck & Devrient (G&D)",
											download: "https://statics.safeweb.com.br/portals/10/downloads/SafeSignIC30124-x64-win-tu-admin.exe",
											vimeoId: 1038600347,
											linkManual: '/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_manual_geiseck_e_devrient_windows.pdf'
										},
										{
											id: "dexon",
											label: "Dexon",
											download: " https://publicado.dexon.ind.br/DXSafe/Instaladores/DXSafe_1.x/1.0.33/Instalador%20DXSafe%20Middleware%20-%20SPC%201.0.33.exe",
											vimeoId: 1038600912,
											linkManual: '/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_manual_dexon_windows.pdf'
										},
									],
								},
								{
									id: "cartao",
									label: "Cartão",
									models: [
										{
											id: "geiseck--devrient-gd---gemalto",
											label: "Geiseck & Devrient (G&D) - GEMALTO",
											download: "https://statics.safeweb.com.br/portals/10/downloads/SafeSignIC30124-x64-win-tu-admin.exe",
											vimeoId:1038600347,
											linkManual: '/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_manual_geiseck_e_devrient_windows.pdf'
										},
										{
											id: "idemia2---oberthur",
											label: "IDEMIA2 - OBERTHUR",
											download: "/uploads/hotsite_certificado_digital/oberthur_awp_sr1_user_64bit_v5.1.8.msi",
											vimeoId: 1038600423,
											linkManual: '/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_manual_oberthur_windows.pdf'
										},
									],
								},
							],
						},
						{
							id: "32-bit",
							label: "32-bit / x86",
							midias: [
								{
									id: "token",
									label: "Token",
									models: [
										{
											id: "safenet",
											label: "SafeNet",
											download: "/uploads/hotsite_certificado_digital/safenet_32bits_v10.7.msi",
											vimeoId: 1038600640,
											linkManual: '/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_manual_safenet_windows.pdf'
										},
										{
											id: "geiseck--devrient-gd",
											label: "Geiseck & Devrient (G&D)",
											download: "https://statics.safeweb.com.br/portals/10/downloads/SafeSignIC30124-x86-win-tu-admin.exe",
											vimeoId: 1038600347,
											linkManual: '/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_manual_geiseck_e_devrient_windows.pdf'
										},
									],
								},
								{
									id: "cartao",
									label: "Cartão",
									models: [
										{
											id: "geiseck--devrient-gd---gemalto",
											label: "Geiseck & Devrient (G&D) - GEMALTO",
											download: "https://statics.safeweb.com.br/portals/10/downloads/SafeSignIC30124-x86-win-tu-admin.exe",
											vimeoId: 1038600347,
											linkManual: '/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_manual_geiseck_e_devrient_windows.pdf'
										},
										{
											id: "idemia2---oberthur",
											label: "IDEMIA2 - OBERTHUR",
											download: "/uploads/hotsite_certificado_digital/oberthur_awp_sr1_user_32bit_v5.1.8.msi",
											vimeoId: 1038600423,
											linkManual: '/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_manual_oberthur_windows.pdf'
										},
									],
								},
							],
						},
					],
				},
				{
					id: "macos",
					label: "MacOS ",
					versions: [{
							id: "os-ventura",
							label: "OS Ventura",
							midias: [
								{
									id: "token",
									label: "Token",
									models: [
										{
											id: "geiseck--devrient-gd",
											label: "Geiseck & Devrient (G&D)",
											download: "https://safesign.gdamericadosul.com.br/content/SafeSignMacOS3.8.zip",
											vimeoId: 1038600263,
											linkManual: "/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_geiseck_e_devrient_macos.pdf"
										},
									],
								},
								{
									id: "cartao",
									label: "Cartão",
									models: [
										{
											id: "geiseck--devrient-gd",
											label: "Geiseck & Devrient (G&D)",
											download: "https://safesign.gdamericadosul.com.br/content/SafeSignMacOS3.8.zip",
											vimeoId: 1038600263,
											linkManual: "/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_geiseck_e_devrient_macos.pdf"
										}
									],
								},
							],
						},
						{
							id: "os-sonoma",
							label: "OS Sonoma",
							midias: [
								{
									id: "token",
									label: "Token",
									models: [
										{
											id: "geiseck--devrient-gd",
											label: "Geiseck & Devrient (G&D)",
											download: "https://safesign.gdamericadosul.com.br/content/SafeSignMacOS3.8.zip",
											vimeoId: 1038600263,
											linkManual: "/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_geiseck_e_devrient_macos.pdf"
										},
									],
								},
								{
									id: "cartao",
									label: "Cartão",
									models: [
										{
											id: "geiseck--devrient-gd",
											label: "Geiseck & Devrient (G&D)",
											download: "https://safesign.gdamericadosul.com.br/content/SafeSignMacOS3.8.zip",
											vimeoId: 1038600263,
											linkManual: "/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_geiseck_e_devrient_macos.pdf"
										}
									],
								},
							],
						},
						{
							id: "os-sequoia",
							label: "OS Sequoia",
							midias: [
								{
									id: "token",
									label: "Token",
									models: [
										{
											id: "geiseck--devrient-gd",
											label: "Geiseck & Devrient (G&D)",
											download: "https://safesign.gdamericadosul.com.br/content/SafeSignMacOS3.8.zip",
											vimeoId: 1038600263,
											linkManual: "/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_geiseck_e_devrient_macos.pdf"
										}
									],
								},
								{
									id: "cartao",
									label: "Cartão",
									models: [
										{
											id: "geiseck--devrient-gd",
											label: "Geiseck & Devrient (G&D)",
											download: "https://safesign.gdamericadosul.com.br/content/SafeSignMacOS3.8.zip",
											vimeoId: 1038600263,
											linkManual: "/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_geiseck_e_devrient_macos.pdf"
										}
									],
								},
							],
						},
						{
							id: "ox-xs-big-sur",
							label: "OS X Big Sur",
							midias: [
								{
									id: "token",
									label: "Token",
									models: [
										{
											id: "geiseck--devrient-gd",
											label: "Geiseck & Devrient (G&D)",
											download: "https://safesign.gdamericadosul.com.br/content/SafeSign%20IC%20Standard%20MacOS%203.7.0.1-AET.000%20universal.zip",
											vimeoId: 1038600263,
											linkManual: "/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_geiseck_e_devrient_macos.pdf"
										},
										{
											id: "safenet",
											label: "SafeNet",
											download: "/uploads/hotsite_certificado_digital/safenet_bigsur.zip",
											vimeoId: 1038600524,
											linkManual: "/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_safenet_macos.pdf"
										},
									],
								},
								{
									id: "cartao",
									label: "Cartão",
									models: [
										{
											id: "geiseck--devrient-gd",
											label: "Geiseck & Devrient (G&D)",
											download: "https://safesign.gdamericadosul.com.br/content/SafeSign%20IC%20Standard%20MacOS%203.7.0.1-AET.000%20universal.zip",
											vimeoId: 1038600263,
											linkManual: "/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_geiseck_e_devrient_macos.pdf"
										}
									],
								},
							],
						},
						{
							id: "os-xs-catalina",
							label: "OS X Catalina",
							midias: [
								{
									id: "token",
									label: "Token",
									models: [
										{
											id: "geiseck--devrient-gd",
											label: "Geiseck & Devrient (G&D)",
											download: "https://safesign.gdamericadosul.com.br/content/SafeSign%20IC%20Standard%20MacOS%20macos%203.7.1.0-AET.000%20x86_64.zip",
											vimeoId: 1038600263,
											linkManual: "/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_geiseck_e_devrient_macos.pdf"
										},
										{
											id: "safenet",
											label: "SafeNet",
											download: "/uploads/hotsite_certificado_digital/safenet_catalina.zip",
											vimeoId: 1038600524,
											linkManual: "/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_safenet_macos.pdf"
										}
									],
								},
								{
									id: "cartao",
									label: "Cartão",
									models: [
										{
											id: "geiseck--devrient-gd---gemalto",
											label: "Geiseck & Devrient (G&D) - GEMALTO",
											download: "https://safesign.gdamericadosul.com.br/content/SafeSign%20IC%20Standard%20MacOS%20macos%203.7.1.0-AET.000%20x86_64.zip",
											vimeoId: 1038600263,
											linkManual: "/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_geiseck_e_devrient_macos.pdf"
										}
									],
								},
							],
						},
						{
							id: "os-xs-monterey",
							label: "OS X Monterey",
							midias: [
								{
									id: "token",
									label: "Token",
									models: [
										{
											id: "geiseck--devrient-gd",
											label: "Geiseck & Devrient (G&D)",
											download: "https://safesign.gdamericadosul.com.br/content/SafeSign%20IC%20Standard%20MacOS%20macos%203.7.1.0-AET.000%20x86_64.zip",
											vimeoId: 1038600263,
											linkManual: "/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_geiseck_e_devrient_macos.pdf"
										},
										{
											id: "safenet",
											label: "SafeNet",
											download: "/uploads/hotsite_certificado_digital/safenet_monterey.zip",
											vimeoId: 1038600524,
											linkManual: "/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_safenet_macos.pdf"
										}
									],
								},
								{
									id: "cartao",
									label: "Cartão",
									models: [
										{
											id: "geiseck--devrient-gd",
											label: "Geiseck & Devrient (G&D)",
											download: "https://safesign.gdamericadosul.com.br/content/SafeSign%20IC%20Standard%20MacOS%20macos%203.7.1.0-AET.000%20x86_64.zip",
											vimeoId: 1038600263,
											linkManual: "/certificacaodigital/docs/suporte/instalacao/a3-token-cartao/a3_token_cartao_presencial_geiseck_e_devrient_macos.pdf"
										}
									],
								},
							],
						},
					],
				},
			],
		};
	},
	components: {
		PassoAPasso,
		SelectOption,
	},
};
</script>
<style>
.passo-a-passo {
	grid-template-columns: minmax(0, 1fr) max-content;
}
.passo-a-passo aside {
	width: 440px;
}

li[data-step] {
	opacity: 0.3;
}
a[disabled] {
	cursor: default;
	pointer-events: none;
}
</style>
